import { render, staticRenderFns } from "./TmpLogoOverlay.vue?vue&type=template&id=3bcaad3c&scoped=true&"
import script from "./TmpLogoOverlay.vue?vue&type=script&lang=ts&"
export * from "./TmpLogoOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./TmpLogoOverlay.vue?vue&type=style&index=0&id=3bcaad3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcaad3c",
  null
  
)

export default component.exports